module.exports = __webpack_public_path__ + "img/blog-img.f4752bac.jpg";